module.exports = __webpack_public_path__ + "assets/img/Pop-Menu-Landing-Page-+-Website-w720.0d46a2d4.jpg";